module.exports = __webpack_public_path__ + "img/logo.ddd20849.png";